import { isNil } from 'lodash';
import { DEFAULT_LINE_PROPS } from '../../../../../Shape/config/Shapes';

const getConnectionStrategy = shape => (isNil(shape.get('connectionStrategy')) ? DEFAULT_LINE_PROPS.connectionStrategy : shape.get('connectionStrategy'));

export default getConnectionStrategy;
